
export const questionBank = [
       [
          {
              question: "What is the capital of France?",
              options: ["Berlin", "Madrid", "Paris", "Rome"],
              correctAnswer: 2
          },
          {
              question: "How many sides does a pentagon have?",
              options: ["Four", "Five", "Six", "Seven"],
              correctAnswer: 1
          },
          {
              question: "Which planet is known as the Red Planet?",
              options: ["Earth", "Mars", "Jupiter", "Saturn"],
              correctAnswer: 1
          },
          {
            question: "What is the chemical symbol for water?",
            options: ["W", "WA", "H2O", "AQ"],
            correctAnswer: 2
        },
        {
            question: "Which gas do plants absorb from the atmosphere?",
            options: ["Oxygen", "Carbon Dioxide", "Nitrogen", "Hydrogen"],
            correctAnswer: 1
        },
        {
            question: "What is the largest organ in the human body?",
            options: ["Heart", "Brain", "Liver", "Skin"],
            correctAnswer: 3
        },
        {
            question: "Who was the first President of the United States?",
            options: ["Thomas Jefferson", "John Adams", "George Washington", "Abraham Lincoln"],
            correctAnswer: 2
        },
        {
            question: "In which year did World War II end?",
            options: ["1943", "1945", "1947", "1950"],
            correctAnswer: 1
        },
        {
            question: "Which ancient civilization built the pyramids at Giza?",
            options: ["Greeks", "Romans", "Mayans", "Egyptians"],
            correctAnswer: 3
        },
        {
            question: "Which country is known as the Land of the Rising Sun?",
            options: ["China", "Japan", "Thailand", "South Korea"],
            correctAnswer: 1
        }
     
      ],
      [
          {
              question: "Who painted the Mona Lisa?",
              options: ["Vincent van Gogh", "Pablo Picasso", "Leonardo da Vinci", "Michelangelo"],
              correctAnswer: 2
          },
          {
              question: "What is the largest mammal on Earth?",
              options: ["African Elephant", "Blue Whale", "Giraffe", "Polar Bear"],
              correctAnswer: 1
          },
          {
              question: "Which element has the chemical symbol 'Au'?",
              options: ["Silver", "Gold", "Aluminum", "Argon"],
              correctAnswer: 1
          },
          {
            question: "Which element has the atomic number 1?",
            options: ["Helium", "Hydrogen", "Oxygen", "Carbon"],
            correctAnswer: 1
        },
        {
            question: "What particle has a positive charge?",
            options: ["Proton", "Neutron", "Electron", "Photon"],
            correctAnswer: 0
        },
        {
            question: "What is the approximate speed of light in vacuum?",
            options: ["300,000 km/s", "150,000 km/s", "1,000,000 km/s", "30,000 km/s"],
            correctAnswer: 0
        },
        {
            question: "Who was the female pharaoh of Ancient Egypt?",
            options: ["Nefertiti", "Cleopatra", "Hatshepsut", "Isis"],
            correctAnswer: 2
        },
        {
            question: "Which year did the Berlin Wall fall?",
            options: ["1985", "1989", "1991", "1993"],
            correctAnswer: 1
        },
        {
            question: "Who wrote 'The Communist Manifesto'?",
            options: ["Lenin", "Stalin", "Marx and Engels", "Trotsky"],
            correctAnswer: 2
        },
        {
            question: "What is the capital city of Australia?",
            options: ["Sydney", "Melbourne", "Canberra", "Perth"],
            correctAnswer: 2
        }
      ],
      [
          {
              question: "In which year was the first iPhone released?",
              options: ["2005", "2007", "2009", "2011"],
              correctAnswer: 1
          },
          {
              question: "Who wrote 'Hamlet'?",
              options: ["Charles Dickens", "William Shakespeare", "Jane Austen", "Mark Twain"],
              correctAnswer: 1
          },
          {
              question: "What is the capital of Canada?",
              options: ["Toronto", "Vancouver", "Montreal", "Ottawa"],
              correctAnswer: 3
          },
          {
            question: "What is the name of the galaxy containing our solar system?",
            options: ["Andromeda", "Milky Way", "Triangulum", "Messier 87"],
            correctAnswer: 1
        },
        {
            question: "What is the Heisenberg Uncertainty Principle related to?",
            options: ["Classical Mechanics", "Quantum Mechanics", "Thermodynamics", "Relativity"],
            correctAnswer: 1
        },
        {
            question: "Which scientist proposed the theory of general relativity?",
            options: ["Isaac Newton", "Albert Einstein", "Niels Bohr", "Marie Curie"],
            correctAnswer: 1
        },
        {
            question: "When was the Magna Carta signed?",
            options: ["1215", "1315", "1415", "1515"],
            correctAnswer: 0
        },
        {
            question: "Which country was NOT part of the Allied Powers during World War I?",
            options: ["Great Britain", "France", "Germany", "United States"],
            correctAnswer: 2
        },
        {
            question: "Who was the first Emperor of China's Qin Dynasty?",
            options: ["Qin Shi Huang", "Sun Tzu", "Confucius", "Wu Zetian"],
            correctAnswer: 0
        },
        {
            question: "What is the smallest country in the world by land area?",
            options: ["Monaco", "Nauru", "Vatican City", "San Marino"],
            correctAnswer: 2
        },
      ]
    ];
